/*! LQ NameSpace | Copyright 2015 Loto Quebec Inc. */
/*global jQuery,lq,console*/
/*jshint -W030*/
;
(function ($, document, window, lq) {
    'use strict';

    //Stop vertical scroll on touch device
    window.blockMenuHeaderScroll = false;
    $(window).on('touchstart', function (e) {
        if ($(e.target).closest('.owl-grab').length == 1) {
            blockMenuHeaderScroll = true;
        }
    });
    $(window).on('touchend', function () {
        blockMenuHeaderScroll = false;
    });
    $(window).on('touchmove', function (e) {
        if (blockMenuHeaderScroll) {
            e.preventDefault();
        }
    });


    /* variable pour les stats - incrémentée de 1 en bas de fonction $('.galerie-owl').each() */
    var GalerieNum = 1;
    $('.galerie-owl').each(function () {
        var galerie = $(this);

        $(this).owlCarousel({
            dots: (galerie.data('dots') || false),
            touchDrag: true,
            rewind: false,
            loop: false,
            margin: 10,
            startPosition: 0,
            autoWidth: false,
            stagePadding: 0,
            smartSpeed: (galerie.data('autoplay-speed') || 450),
            slideBy: (galerie.data('slide-by') || 1),
            autoplay: false,
            URLhashListener: true,
            nav: false,
            navText: [
                '<span class="sr-only">' + (galerie.data('nav-text-prev') || lq.i18n.get('nav-text-prev')) + '</span>‹',
                '<span class="sr-only">' + (galerie.data('nav-text-next') || lq.i18n.get('nav-text-next')) + '</span>›'
            ],

            responsive: {
                0: {
                    items: (galerie.data('responsive-items-small') || 1),
                },
                768: {
                    items: (galerie.data('responsive-items-medium') || 1),
                },
                1200: {
                    items: (galerie.data('responsive-items-large') || 1),
                    nav: true,
                    stagePadding: 10,
                    margin: 15,
                    touchDrag: false,
                    mouseDrag: true,
                },
            },
        })
        var slideNum = 1;
        $('.owl-item:not(.cloned)', galerie).each(function (e) {
            $(this).find("a.card.galerie").attr({
                id: 'galerie-' + GalerieNum + '-slide-num-' + slideNum.toString(),
                dataga: galerie.data("ga-analytics")
            });
            slideNum++;
        });
        GalerieNum++;
    });

    //Pour configurer le bouton de la galerie selon la couleur sélectionnée
    $('.bouton-galerie').each(function () {
        var bouton = $(this);
        if (bouton.data('color')) {
            var color = bouton.data('color');

            // https://api.jquery.com/css/#css-properties
            $('.btnContainer', this).css("background-color", color);

            /*$('.btn', this).on("focus mouseenter touchstart", function () {
                $('.btnContainer', this).css({ "background-color": color });
            });
            $('.btn', this).on("focusout mouseleave touchend", function () {
                $('.btnContainer', this).css({ "background-color": "rgb(255, 255, 255)" });
            });*/
        }
    });

    // Update global scope lq namespace
    window.lq = lq;

    // Auto trigger all self implemented (plugin) functionalities
    lq.load.push(
        "lq.utils", [
        'setupGalerieOwl'
    ]
    );

}(jQuery, document, window, (window.lq || {})));